/** Identification document types, used to populate NIF/CIF type selectors. */
export const NIF_TYPES: { code: string; name: string }[] = [
  { code: 'nif', name: 'NIF' },
  { code: 'dni', name: 'DNI' },
  { code: 'cif', name: 'CIF' },
  { code: 'nie', name: 'NIE' },
  { code: 'pasaporte', name: 'Pasaporte' },
  { code: 'otro', name: 'Otro' },
];
